<template>
  <div class="current-step-title">
    <h2 class="current-step-title__text">{{ currentStep }}</h2>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import pinia from '../../core/pinia';
import { useStepsStore } from '../../stores';

const stepsStore = useStepsStore(pinia);
const steps = computed(() => stepsStore.getSteps);
const currentStep = computed(() => {
  if (!steps.value?.length) return '';
  const currentStepObject = steps.value.find((step) => step.name === stepsStore.getCurrentStep);
  return currentStepObject?.title;
});
</script>

<style scoped lang="scss">
.current-step-title {
  display: flex;
  padding: 16px 0 22px 0;

  &__text {
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    letter-spacing: 0%;
    color: #64747C;
    margin: 0;
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .current-step-title {
    padding: 8px 0;
  }
}
</style>